import React, { useState, useEffect } from 'react';
import { CModal, CModalHeader, CModalBody, CModalTitle, CButton } from '@coreui/react';
import { BsArrowRight } from 'react-icons/bs';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
// import { Weight } from 'lucide-react';
import api from '../../../service/caller';
import { getUserIdFromToken } from '../../../utils/authUtils';

const SignVitalForm = ({ onClose }) => {
    const { state } = useLocation();
    const { existingSignsVital } = state;
    const navigate = useNavigate();
    const { appointmentId } = useParams();
    const [showModal, setShowModal] = useState(false);
    const [showsuccessModal, setShowsuccessModal] = useState(false);
    const [signVitalData, setSignVitalData] = useState({
        bodytemperature: '',
        bloodPressure: '',
        heartRate: '',
        respiratoryRate: '',
        oxygenSaturation: '',
        weight: '',
        height: '',
        details: '',
    });

    // Pré-remplissage des données lors du montage
    useEffect(() => {
        if (existingSignsVital) {
            setSignVitalData({
                bodytemperature: existingSignsVital.bodytemperature,
                bloodPressure: existingSignsVital.bloodPressure,
                heartRate: existingSignsVital.heartRate,
                respiratoryRate: existingSignsVital.respiratoryRate,
                oxygenSaturation: existingSignsVital.oxygenSaturation,
                weight: existingSignsVital.weight,
                height: existingSignsVital.height,
                details: existingSignsVital.details,
            });
        }
    }, [existingSignsVital]);

    useEffect(() => {
        if (appointmentId) {
            setShowModal(true);  // Ouvre le modal si l'ID du rendez-vous est valide
        }
    }, [appointmentId]); // Dépendance sur appointmentId pour mettre à jour la visibilité du modal

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSignVitalData((prevData) => ({ ...prevData, [name]: value }));
    };
    
    // Lorsque l'ID de l'appointment est disponible, on récupère les signes vitaux
    useEffect(() => {
        const fetchSignVitalData = async () => {
            try {
                const response = await api.get(`/clinic/signvitalforappointment/${appointmentId}`);
                if (response.data) {
                    setSignVitalData(response.data); // Remplir les champs avec les données existantes si disponibles
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des signes vitaux:', error);
            }
        };

        if (appointmentId) {
            fetchSignVitalData();
        }
    }, [appointmentId]); // Fetch à chaque changement de `appointmentId`

    const handleSubmit = async (e) => {
        e.preventDefault();
        const recordedBy = getUserIdFromToken(); // Récupérer l'ID utilisateurconnecte
        const formdata = { appointmentId, recordedBy, ...signVitalData };
        try {
            const url = existingSignsVital ? `/clinic/updatesignsvitaux/${existingSignsVital._id}` : 'clinic/addsignsvitaux';
            const method = existingSignsVital ? 'put' : 'post';
            await api[method](url, formdata);

            // setShowModal(false); 
            setShowsuccessModal(true)
        } catch (error) {
            console.error('Erreur lors de l\'ajout ou de la modification des signes vitaux:', error);
        }
    };

    // Fonction pour fermer le modal de succès
    const handlesuccessModalClose = () => {
        navigate('/hospitaladmin/Appointmentlist')
    };

    return (
        <CModal
            className="newregistermodal signvital"
            alignment="center"
            scrollable
            size="lg"
            visible={showModal}
            onClose={() => setShowModal(false)}
            aria-labelledby="VerticallyCenteredScrollableExample2"
        >
            <CModalHeader toggle={onClose}>
                {existingSignsVital ? "Edit Signes Vitaux" : "Add Signes Vitaux"}
            </CModalHeader>
            <CModalBody>
                <form onSubmit={handleSubmit}>
                    <div className="form-row row">
                        <div className="form-group col-md-6">
                            <label htmlFor="bodytemperature">Body Temperature (°C)</label>
                            <input
                                type="text"
                                name="bodytemperature"
                                id="bodytemperature"
                                value={signVitalData.bodytemperature}
                                onChange={handleChange}
                                required
                                placeholder="Enter temperature"
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="heartRate">Heart Rate (bpm)</label>
                            <input
                                type="text"
                                name="heartRate"
                                id="heartRate"
                                value={signVitalData.heartRate}
                                onChange={handleChange}
                                required
                                placeholder="Enter heart rate"
                            />
                        </div>
                    </div>

                    <div className="form-row row">
                        <div className="form-group col-md-6">
                            <label htmlFor="bloodPressure">Blood Pressure (mmHg)</label>
                            <input
                                type="text"
                                name="bloodPressure"
                                id="bloodPressure"
                                value={signVitalData.bloodPressure}
                                onChange={handleChange}
                                required
                                placeholder="Enter blood pressure"
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="oxygenSaturation">Oxygen Saturation (%)</label>
                            <input
                                type="text"
                                name="oxygenSaturation"
                                id="oxygenSaturation"
                                value={signVitalData.oxygenSaturation}
                                onChange={handleChange}
                                required
                                placeholder="Enter oxygen saturation"
                            />
                        </div>
                    </div>

                    <div className="form-row row">
                        <div className="form-group col-md-6">
                            <label htmlFor="weight">Weight (kg)</label>
                            <input
                                type="text"
                                name="weight"
                                id="weight"
                                value={signVitalData.weight}
                                onChange={handleChange}
                                required
                                placeholder="Enter weight"
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="height">Height (cm)</label>
                            <input
                                type="text"
                                name="height"
                                id="height"
                                value={signVitalData.height}
                                onChange={handleChange}
                                required
                                placeholder="Enter height"
                            />
                        </div>
                    </div>

                    <div className="form-row row">
                        <div className="form-group col-md-6">
                            <label htmlFor="respiratoryRate">Respiratory Rate (breaths/min)</label>
                            <input
                                type="text"
                                name="respiratoryRate"
                                id="respiratoryRate"
                                value={signVitalData.respiratoryRate}
                                onChange={handleChange}
                                placeholder="Enter respiratory rate"
                            />
                        </div>

                        <div className="col-md-6">
                            <div className="mx-auto">
                                <p>
                                    <strong style={{ color: '#191B1C' }}>BMI =</strong> <strong style={{ color: '#28A745' }}>20.2</strong>
                                    <br />
                                    <span style={{ color: '#191B1CB8' }}>(Normal BMI)</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="details">Details</label>
                        <textarea
                            name="details"
                            id="details"
                            value={signVitalData.details} // Valeur de l'état ici
                            onChange={handleChange}
                        />
                    </div>

                    <div className="savenewuser form-group d-flex justify-content-center">
                        <CButton type="submit">
                            Continue &nbsp; <BsArrowRight />
                        </CButton>
                    </div>
                </form>
            </CModalBody>



            {/* Modal de succès */}
            {showsuccessModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="py-2" style={{ background: "#28A7451A" }}>
                                <h5 className="text-center fw-bold" style={{ color: "#28A745" }}>
                                    SUCCESS
                                </h5>
                            </div>
                            <div className="modal-body">
                                <p className="text-center" style={{ color: "#6D7278" }}>
                                    Patient: <strong className="text-dark ms-2">00056</strong>
                                </p>
                                <p className="text-center">
                                    Vital signs for patient <span style={{ textDecoration: "underline" }}>Casos Billal</span>{" "}
                                    updated successfully
                                </p>
                                <p className="text-center" style={{ textDecoration: "underline" }}>
                                    The patient can now wait for his consultation
                                </p>

                                <div className="col-12 col-md-6 mx-auto mb-3">
                                    <button
                                        className="btn btn-suc w-100 text-white py-3"
                                        style={{ background: "#28A745" }}
                                        onClick={handlesuccessModalClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </CModal>
    );
};

export default SignVitalForm;
